//#region src/components/Tree/helpers/getTreeExpansionIds.ts
var e = (e) => {
	let t = /* @__PURE__ */ new Set(), n = /* @__PURE__ */ new Set(), r = (e) => {
		for (let i of e) (i.children?.length || i.helpTextElement) && (t.add(i.id), i.collapsible && n.add(i.id)), i.children && r(i.children);
	};
	return r(e), {
		availableIds: t,
		collapsibleIds: n
	};
};
//#endregion
export { e as getTreeExpansionIds };
